import api from '../../service/api'
import i18n from '../../plugins/i18n'

const state = {
    language: 'zh',
    langType: 1
};

const getters = {};

const actions = {
    changeLanguage({commit}, key) {
        localStorage.setItem('locale', key);
        window.location.reload();
        // commit('setLanguage', key);

    }
};

const mutations = {
    setLanguage(state, key) {
        localStorage.setItem('locale', key);
        state.language = key;
        i18n.locale = key;
        switch (key) {
            case 'zh':
                state.langType = 1;
                break;
            case 'en':
                state.langType = 2;
                break;
            case 'de':
                state.langType = 3;
                break;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
